import { getIcons } from '_helpers';
import React from 'react';
import { Modal } from 'react-bootstrap';

export { DeleteModal };

function DeleteModal ({ show, handleClose, handleDelete, entityName }) {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <img src={getIcons('deleteForeverOutlinedBlack')} alt='icone suppression'/>
                    Supprimer {entityName}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Vous êtes sur le point de supprimer {entityName}. Êtes-vous certain de vouloir continuer ?</p>
            </Modal.Body>
            <Modal.Footer>
                <button className='btn btn-custom btn-custom-secondary border-0' onClick={handleClose}>
                    <img src={getIcons("clearOutlinedBlack")} alt="icon return" className="btn-custom-icon"/>
                    Annuler
                </button>
                <button className='btn btn-custom btn-custom-danger border-0' onClick={handleDelete}>
                    <img src={getIcons('deleteForeverOutlined')} alt="delete icon" className='btn-custom-icon' />
                    Supprimer
                </button>
            </Modal.Footer>
        </Modal>
    );
};
